"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformReceivableForDataLake = exports.formatReceivableResponseTapeForDatalake = exports.NONE = void 0;
const _ = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
exports.NONE = 'NONE';
/**
 * Transforms arrays contained in receivableResponseTape data structure
 * into objects keyed by elig / conc limit test.  We do not allow arrays in data lake
 * as they are difficult to query, and totally ignored by quicksights.
 *
 * Credit Agreement typeguard enforces keys are unique prior to commit, so assertion should be
 * safe), but we enforce uniqueness here to not rely on CA typeguard.
 */
const formatReceivableResponseTapeForDatalake = ({ receivableResponseTape, borrowingBaseMechanics, logError, }) => {
    const { receivables, concentrationLimitCalculations, } = receivableResponseTape;
    // check for unique concentration keys prior to indexing on key
    const uniqueCLCalcKeySet = concentrationLimitCalculations.reduce((acm, { concentrationLimitKey }) => acm.add(concentrationLimitKey), new Set());
    (0, common_1.finleyAssert)(uniqueCLCalcKeySet.size === concentrationLimitCalculations.length, new common_1.error.FinleyError('concentration limit calc keys must be unique', {
        metadata: {
            logMeta: {
                concentrationLimitCalculations: JSON.stringify(concentrationLimitCalculations),
            },
        },
    }));
    // init empty waiver reason obj
    const concentrationLimitWaiverReasons = {};
    borrowingBaseMechanics.loanProducts.forEach((lp) => {
        lp.concentrationLimitConfigs.forEach((clc) => {
            clc.waiveConfigs.forEach((wc) => {
                if (!concentrationLimitWaiverReasons[clc.propertyKey]) {
                    concentrationLimitWaiverReasons[clc.propertyKey] = {};
                }
                concentrationLimitWaiverReasons[clc.propertyKey][wc.reason] = 0;
            });
        });
    });
    borrowingBaseMechanics.multiLoanProductConcentrationLimits.forEach((mlp) => {
        mlp.waiveConfigs.forEach((wc) => {
            if (!concentrationLimitWaiverReasons[mlp.propertyKey]) {
                concentrationLimitWaiverReasons[mlp.propertyKey] = {};
            }
            concentrationLimitWaiverReasons[mlp.propertyKey][wc.reason] = 0;
        });
    });
    const explodedConcentrationLimitReasons = concentrationLimitCalculations.reduce((acc, calc) => {
        // eslint-disable-next-line no-param-reassign
        acc[calc.concentrationLimitKey] = {
            concentrationLimit: calc.concentrationLimit,
            concentrationAmount: calc.concentrationAmount,
            concentration: calc.concentration, // Note that this is the starting weighted average value for weighted average properties
            complianceStatus: calc.complianceStatus, // if there is a global concentration waiver in effect, this will be set to "WAIVED"
            concentrationLimitKickout: 0, // to be updated later if receivable has a kickout for this calc
            waiveReasons: exports.NONE, // to be updated later if receivable has global individual waiver set, or if the receivable was included in a concentration limit was holistically waived
        };
        return acc;
    }, {});
    return (0, remeda_1.map)(receivables, (rec) => {
        // destruct all array properties for flattening
        const { concentrationLimitReasons, eligibilityStatuses, concentrationLimitWaivers, ...rest } = rec;
        // check for unique keys prior to indexing on key
        const uniqueEligibilityCriteriaKeySet = eligibilityStatuses.reduce((acm, { eligibilityCriteriaKey }) => acm.add(eligibilityCriteriaKey), new Set());
        (0, common_1.finleyAssert)(uniqueEligibilityCriteriaKeySet.size === eligibilityStatuses.length, new common_1.error.FinleyError('eligibility criteria keys must be unique', {
            metadata: {
                logMeta: {
                    eligibilityStatuses: JSON.stringify(eligibilityStatuses),
                },
            },
        }));
        const eligibilityStatusesObj = (0, remeda_1.reduce)(eligibilityStatuses, (acc, status) => {
            // eslint-disable-next-line no-param-reassign
            acc[status.eligibilityCriteriaKey] = {
                eligibilityStatus: status.eligibilityStatus,
            };
            return acc;
        }, {});
        // check for unique keys prior to indexing on key
        const uniqueCLKeySet = concentrationLimitReasons.reduce((acm, { propertyKey }) => acm.add(propertyKey), new Set());
        (0, common_1.finleyAssert)(uniqueCLKeySet.size === concentrationLimitReasons.length, new common_1.error.FinleyError('concentration limit reason keys must be unique', {
            metadata: {
                logMeta: {
                    concentrationLimitReasons: JSON.stringify(concentrationLimitReasons),
                },
            },
        }));
        // copy the exploded template
        const concentrationLimitReasonsObj = _.cloneDeep(explodedConcentrationLimitReasons);
        // copy the waiver template
        const concentrationLimitWaiverReasonsObj = _.cloneDeep(concentrationLimitWaiverReasons);
        // concentrationLimitReasons is sparsely populated with only non-zero concentration kickout amounts
        (0, remeda_1.forEach)(concentrationLimitReasons, ({ propertyKey, concentrationLimitKickout }) => {
            (0, common_1.finleyAssert)(propertyKey in concentrationLimitReasonsObj, new common_1.error.FinleyError('concentrationLimit property key must exist in concentration limit reasons to update concentrationLimitKickout', { metadata: { logMeta: { propertyKey } } }));
            // update the template concentration limit kickout
            concentrationLimitReasonsObj[propertyKey].concentrationLimitKickout = concentrationLimitKickout;
        });
        // we init initialWaiverObj as empty object, or, if the receivable
        // has an individual global waiver, we set "individualWaiver" for each concentrationLimit
        const initialWaiverObj = rec.requiredIntermediateFields
            .waiveAllConcentration
            ? (0, remeda_1.reduce)(concentrationLimitCalculations, (acc, { concentrationLimitKey }) => {
                // eslint-disable-next-line no-param-reassign
                acc[concentrationLimitKey] = ['waiveAllConcentration'];
                return acc;
            }, {})
            : {};
        // now we can add any global concentration limit waivers and individual receivable concentration limit waivers to the inital waiver obj
        const waiversObj = (0, remeda_1.reduce)(concentrationLimitWaivers, (acc, { propertyKey, waiveReason, waivedAmount }) => {
            if (!acc[propertyKey]) {
                // eslint-disable-next-line no-param-reassign
                acc[propertyKey] = [];
            }
            acc[propertyKey].push(waiveReason);
            // this should be defined during initial init, but unclear how well waivers are supported throughout the codebase
            // will be defensive for now
            if (concentrationLimitWaiverReasonsObj[propertyKey] &&
                typeof concentrationLimitWaiverReasonsObj[propertyKey][waiveReason] === 'number') {
                // update the concentrationLimitWaiverReasons amounts
                concentrationLimitWaiverReasonsObj[propertyKey][waiveReason] =
                    waivedAmount ?? 0;
            }
            else {
                logError(new Error(`concentrationLimitWaiverReasons is missing [propertyKey:${propertyKey}] [waiveReason:${waiveReason}]. This should be investigated, but did not abort the process.`));
            }
            return acc;
        }, initialWaiverObj);
        (0, remeda_1.forEach)((0, remeda_1.toPairs)(waiversObj), ([propertyKey, waiveReasons]) => {
            (0, common_1.finleyAssert)(propertyKey in concentrationLimitReasonsObj, new common_1.error.FinleyError('concentrationLimit property key must exist in concentration limit reasons to update waiver reasons', { metadata: { logMeta: { propertyKey } } }));
            // update the waiver reasons
            concentrationLimitReasonsObj[propertyKey].waiveReasons = waiveReasons.join('|');
        });
        (0, remeda_1.forEach)((0, remeda_1.toPairs)(concentrationLimitWaiverReasonsObj), ([propertyKey, waiveAmounts]) => {
            (0, common_1.finleyAssert)(propertyKey in concentrationLimitReasonsObj, new common_1.error.FinleyError('concentrationLimit property key must exist in concentration limit reasons to update waiver amounts', { metadata: { logMeta: { propertyKey } } }));
            // update the waiver amounts
            concentrationLimitReasonsObj[propertyKey].waiveAmounts = waiveAmounts;
        });
        // compliance status is only set for global concentration limit waivers
        // but since a receivable may have been individually waived, we may need to update
        // compliance status
        (0, remeda_1.forEach)((0, remeda_1.keys)(concentrationLimitReasonsObj), (key) => {
            if (concentrationLimitReasonsObj[key].waiveReasons !== exports.NONE) {
                concentrationLimitReasonsObj[key].complianceStatus = 'WAIVED';
            }
        });
        return {
            ...rest,
            concentrationLimitReasons: concentrationLimitReasonsObj,
            eligibilityStatuses: eligibilityStatusesObj,
        };
    });
};
exports.formatReceivableResponseTapeForDatalake = formatReceivableResponseTapeForDatalake;
/**
 * STREAM USAGE ONLY
 *
 * mostly copy/paste of above, but done per receivable
 * exploded concentration limits must be provided by caller
 */
const transformReceivableForDataLake = (rec, concentrationLimitCalculations, explodedConcentrationLimitReasons) => {
    // destructure all array properties for flattening
    const { concentrationLimitReasons, eligibilityStatuses, concentrationLimitWaivers, ...rest } = rec;
    // check for unique keys prior to indexing on key
    const uniqueEligibilityCriteriaKeySet = eligibilityStatuses.reduce((acm, { eligibilityCriteriaKey }) => acm.add(eligibilityCriteriaKey), new Set());
    (0, common_1.finleyAssert)(uniqueEligibilityCriteriaKeySet.size === eligibilityStatuses.length, 'eligibility criteria keys must be unique');
    const eligibilityStatusesObj = eligibilityStatuses.reduce((acc, status) => {
        // eslint-disable-next-line no-param-reassign
        acc[status.eligibilityCriteriaKey] = {
            eligibilityStatus: status.eligibilityStatus,
        };
        return acc;
    }, {});
    // check for unique keys prior to indexing on key
    const uniqueCLKeySet = concentrationLimitReasons.reduce((acm, { propertyKey }) => acm.add(propertyKey), new Set());
    (0, common_1.finleyAssert)(uniqueCLKeySet.size === concentrationLimitReasons.length, 'concentration limit reason keys must be unique');
    // copy the exploded template
    const concentrationLimitReasonsObj = _.cloneDeep(explodedConcentrationLimitReasons);
    // concentrationLimitReasons is sparsely populated with only non-zero concentration kickout amounts
    (0, remeda_1.forEach)(concentrationLimitReasons, ({ propertyKey, concentrationLimitKickout }) => {
        (0, common_1.finleyAssert)(propertyKey in concentrationLimitReasonsObj, 'concentrationLimit property key must exist in concentration limit reasons to update concentrationLimitKickout');
        // update the template concentration limit kickout
        concentrationLimitReasonsObj[propertyKey].concentrationLimitKickout = concentrationLimitKickout;
    });
    // we init initialWaiverObj as empty object, or, if the receivable
    // has an individual global waiver, we set "individualWaiver" for each concentrationLimit
    const initialWaiverObj = rec.requiredIntermediateFields.waiveAllConcentration
        ? (0, remeda_1.reduce)(concentrationLimitCalculations, (acc, { concentrationLimitKey }) => {
            // eslint-disable-next-line no-param-reassign
            acc[concentrationLimitKey] = ['waiveAllConcentration'];
            return acc;
        }, {})
        : {};
    // now we can add any global concentration limit waivers and individual receivable concentration limit waivers to the initial waiver obj
    const waiversObj = (0, remeda_1.reduce)(concentrationLimitWaivers, (acc, { propertyKey, waiveReason }) => {
        if (!acc[propertyKey]) {
            // eslint-disable-next-line no-param-reassign
            acc[propertyKey] = [];
        }
        acc[propertyKey].push(waiveReason);
        return acc;
    }, initialWaiverObj);
    (0, remeda_1.forEach)((0, remeda_1.toPairs)(waiversObj), ([propertyKey, waiveReasons]) => {
        (0, common_1.finleyAssert)(propertyKey in concentrationLimitReasonsObj, 'concentrationLimit property key must exist in concentration limit reasons to update waiver reasons');
        // update the waiver reasons
        concentrationLimitReasonsObj[propertyKey].waiveReasons = waiveReasons.join('|');
    });
    // compliance status is only set for global concentration limit waivers
    // but since a receivable may have been individually waived, we may need to update
    // compliance status
    (0, remeda_1.forEach)((0, remeda_1.keys)(concentrationLimitReasonsObj), (key) => {
        if (concentrationLimitReasonsObj[key].waiveReasons !== exports.NONE) {
            concentrationLimitReasonsObj[key].complianceStatus = 'WAIVED';
        }
    });
    return {
        ...rest,
        concentrationLimitReasons: concentrationLimitReasonsObj,
        eligibilityStatuses: eligibilityStatusesObj,
    };
};
exports.transformReceivableForDataLake = transformReceivableForDataLake;
//# sourceMappingURL=receivableResponseTape.js.map